module.exports = __webpack_public_path__ + "img/pg2-article2.0a20aca9.png";